import * as ImagePicker from "expo-image-picker";
import { StatusBar } from "expo-status-bar";
import React, { useState } from "react";
import {
  Dimensions,
  ImageSourcePropType,
  StyleSheet,
  View,
} from "react-native";
import { Colors, IconButton } from "react-native-paper";
import { AdBanner } from "./components/AdBanner";
import { Yoyo } from "./components/Yoyo";

const vw = Dimensions.get("window").width;
const vh = Dimensions.get("window").height;

const PRESET_YOYO_IMAGES: ImageSourcePropType[] = [
  require("./assets/images/yoyo.png"),
  require("./assets/images/wb.png"),
  require("./assets/images/diamond.png"),
  require("./assets/images/hasshoku.png"),
  require("./assets/images/earth.png"),
  require("./assets/images/moon.png"),
  require("./assets/images/cap.png"),
  require("./assets/images/strange0.png"),
  require("./assets/images/strange1.png"),
  require("./assets/images/strange2.png"),
];

export default function App() {
  const [yoyoImages, setYoyoImages] =
    useState<ImageSourcePropType[]>(PRESET_YOYO_IMAGES);
  const [yoyoId, setYoyoId] = useState(0);
  const [yoyoSpeed, setYoyoSpeed] = useState(1);
  const [isRotateRight, setIsRotateRight] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  const currentYoyoImage = yoyoImages[yoyoId];
  const maxYoyoId = yoyoImages.length - 1;

  /** 画像追加 */
  const handleAddYoyoImage = async () => {
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [1, 1],
      quality: 0.5,
    });
    if (!result.cancelled) {
      console.log(result.uri);
      setYoyoImages([...yoyoImages, { uri: result.uri }]);
      setYoyoId(yoyoImages.length);
    }
  };

  /** 画像次へ */
  const handleNextYoyoImage = () => {
    const nextYoyoId = yoyoId + 1;
    setYoyoId(nextYoyoId > maxYoyoId ? 0 : nextYoyoId); // NOTE: 右端なら最初に
  };

  /** 画像前へ */
  const handlePrevYoyoImage = () => {
    const nextYoyoId = yoyoId - 1;
    setYoyoId(nextYoyoId < 0 ? maxYoyoId : nextYoyoId); // NOTE: 左端なら末尾に
  };

  /** スピード変更 */
  const handleToggleSpeed = () => {
    const nextSpeed = yoyoSpeed + 1;
    setYoyoSpeed(nextSpeed > 3 ? 1 : nextSpeed);
  };

  /** 回転方向変更 */
  const handleToggleRotateDirection = () => {
    setIsRotateRight((prev) => !prev);
  };

  /** 開始/終了 */
  const handleTogglePlay = () => {
    setIsPlaying((prev) => !prev);
  };

  return (
    <View style={styles.container}>
      <StatusBar hidden />
      {/* ヨーヨー本体 */}
      <Yoyo
        source={currentYoyoImage}
        speed={yoyoSpeed}
        isRotateRight={isRotateRight}
        isPlaying={isPlaying}
        onPress={handleTogglePlay}
      />
      {/* センター */}
      <View style={styles.absoluteCenter}>
        {/* センターメニュー */}
        <View style={styles.menu}>
          <IconButton
            icon="chevron-left-circle"
            color={Colors.blue900}
            size={50}
            onPress={handlePrevYoyoImage}
          />
          <IconButton
            icon="chevron-right-circle"
            color={Colors.blue900}
            size={50}
            onPress={handleNextYoyoImage}
          />
        </View>
      </View>
      {/* フッター */}
      <View style={styles.footer}>
        {/* フッターメニュー */}
        <View style={styles.menu}>
          {/* 画像追加 */}
          <IconButton
            icon="plus-circle"
            color={Colors.blue900}
            size={50}
            onPress={handleAddYoyoImage}
          />
          <View>
            {/* 回転方向変更 */}
            <IconButton
              icon={isRotateRight ? "rotate-right" : "rotate-left"}
              color={Colors.blue900}
              size={50}
              onPress={handleToggleRotateDirection}
            />
            {/* スピード変更 */}
            <IconButton
              icon={
                [1, 2, 3].includes(yoyoSpeed)
                  ? `fan-speed-${yoyoSpeed}`
                  : "speedometer"
              }
              color={Colors.blue900}
              size={50}
              onPress={handleToggleSpeed}
            />
          </View>
        </View>
        {/* 広告バナー */}
        <AdBanner />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  menu: {
    width: vw,
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  absoluteCenter: {
    position: "absolute",
    top: vh / 2,
    bottom: vh / 2,
  },
  footer: {
    alignItems: "center",
    justifyContent: "center",
  },
});
